module.exports = __webpack_public_path__ + "img/dark_seat.aaefd0c5.png";